export function useStaticAssetsUrl() {
  return import.meta.env.VITE_STATIC_ASSETS_URL;
}
